import { AddCourierRequestInterface, EditCourierRequestInterface } from '@/data/payload/contracts/ManageCourierRequest'
  
  export class AddCourierRequest implements AddCourierRequestInterface {
    private fullname: string
    private phoneNumber: string
    private courierType: string
    private vehicleType: string
    private vehiclePlate: string
    private partnerName: string
    private bankAccountName: string
    private bankId: string
    private bankAccount: string
    private announcementCourierType: string

  
    constructor( 
      fullname: string,
      phoneNumber: string,
      courierType: string,
      vehicleType: string,
      vehiclePlate: string,
      partnerName: string,
      bankAccountName: string,
      bankId: string,
      bankAccount: string,
      announcementCourierType: string
    ) {
      this.fullname = fullname
      this.phoneNumber = phoneNumber
      this.courierType = courierType
      this.vehicleType = vehicleType
      this.vehiclePlate = vehiclePlate
      this.partnerName = partnerName
      this.bankAccountName = bankAccountName
      this.bankId = bankId
      this.bankAccount = bankAccount
      this.announcementCourierType = announcementCourierType
    }
  
    public toPayload(): string {
      return JSON.stringify({
        fullname: this.fullname,
        phone_number: this.phoneNumber,
        courier_type: this.courierType,
        vehicle_type: this.vehicleType,
        vehicle_plate: this.vehiclePlate,
        partner_name: this.partnerName,
        bank_account_name: this.bankAccountName,
        bank_id: this.bankId,
        bank_account: this.bankAccount,
        announcement_courier_type: this.announcementCourierType
      })
    }
  }

  export class EditCourierRequest implements EditCourierRequestInterface {
    private fullname: string
    private phoneNumber: string
    private courierType: string
    private courierStatus: string
    private vehicleType: string
    private vehiclePlate: string
    private partnerName: string
    private bankAccountName: string
    private bankId: string
    private bankAccount: string
    private announcementCourierType: string

  
    constructor( 
      fullname: string,
      phoneNumber: string,
      courierType: string,
      courierStatus: string,
      vehicleType: string,
      vehiclePlate: string,
      partnerName: string,
      bankAccountName: string,
      bankId: string,
      bankAccount: string,
      announcementCourierType: string
    ) {
      this.fullname = fullname
      this.phoneNumber = phoneNumber
      this.courierType = courierType
      this.courierStatus = courierStatus
      this.vehicleType = vehicleType
      this.vehiclePlate = vehiclePlate
      this.partnerName = partnerName
      this.bankAccountName = bankAccountName
      this.bankId = bankId
      this.bankAccount = bankAccount
      this.announcementCourierType = announcementCourierType
    }
  
    public toPayload(): string {
      return JSON.stringify({
        fullname: this.fullname,
        phone_number: this.phoneNumber,
        courier_type: this.courierType,
        courier_status: this.courierStatus,
        vehicle_type: this.vehicleType,
        vehicle_plate: this.vehiclePlate,
        partner_name: this.partnerName,
        bank_account_name: this.bankAccountName,
        bank_id: this.bankId,
        bank_account: this.bankAccount,
        announcement_courier_type: this.announcementCourierType
      })
    }
  }
  
  